module.exports = __webpack_public_path__ + "media/paranoid.6d3fbcf9.mp3";